'use strict';

class MarketplaceApiService {

    static loadPvzList(townCode) {
        return $.ajax({
            url: '/marketplace-calculation/get-pvz-list',
            type: 'GET',
            data: {town_code: townCode}
        });
    }

    static loadParentPvzList(townCode) {
        return $.ajax({
            url: '/marketplace-calculation/get-parent-pvz-list',
            type: 'GET',
            data: {town_code: townCode}
        });
    }

    static loadKladrCode(townCode) {
        return $.ajax({
            url: '/marketplace-calculation/get-kladrcode',
            type: 'GET',
            data: {town_code: townCode}
        });
    }

     static loadDispatchCode(townCode) {
        return $.ajax({
            url: '/marketplace-calculation/get-dispatchcode',
            type: 'GET',
            data: {town_code: townCode}
        });
    }

    static loadServicesCheckboxes(placeIndex) {
        return $.ajax({
            url: '/marketplace-calculation/get-services-checkboxes',
            type: 'GET',
            data: {placeIndex: placeIndex}
        });
    }

    static calculateDelivery(formData) {
        return $.ajax({
            url: '/marketplace-calculation/calculate',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(formData)
        });
    }
}